import http from "./http";
const captcha = {
  image(type) {
    return http.get("captcha/image?type=" + type);
  },
};
export default captcha;
